<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div class="container">
            <div :class="getClass()">
                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <h1 class="title" v-if="data.title">
                        {{ data.title }}
                    </h1>
                </SmartLinkStandaloneElement>
                <SmartLinkStandaloneElement :codename="typ.elements.sub_title.codename">
                    <h3 class="subtitle" v-if="data.subTitle">
                        {{ data.subTitle }}
                    </h3>
                </SmartLinkStandaloneElement>
                <SmartLinkStandaloneElement :codename="typ.elements.content.codename">
                    <p class="content">
                        <RichText :value="data.content" />
                    </p>
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { FullWidthCardModel } from '~/models';
import { contentTypes } from '~/models';
import { paddingOptions } from '~/utils/styling-options'

const typ = contentTypes.full_width_card;

const props = defineProps<{ model: FullWidthCardModel }>();
const paddingModifications = ref<string[]>([]);

const data = {
    title: props.model.elements.title.value,
    subTitle: props.model.elements.subTitle.value,
    content: props.model.elements.content.value,
    textColor: firstOrDefault(props.model.elements.textColor.value),
    paddingModifications: props.model.elements.paddingModificationsPaddingModifications.value.map((item) => item.codename),
    background: firstOrDefault(props.model.elements.background.value),
}

function getClass() {
    let cls = `full-width-card ${paddingOptions(paddingModifications.value)}`;

    if (data.background) {
        cls = `${cls} ${backgroundOptions(data.background.codename)}`
    }

    if (data.textColor) {
        cls = `${cls} ${textColorOptions(data.textColor.codename)}`
    }

    return cls;
}
</script>
